import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_CONGRESS_API_URL
})

export default axiosInstance
